export default "__VITE_ASSET__8a1856bd__"